




























import Vue from "vue";
import _ from "lodash";
import { FilterTypes } from "@/scripts/enums";
import { createNamespacedHelpers } from "vuex";

const { mapActions } = createNamespacedHelpers("home");

export default Vue.extend({
    name: "FilterSelect",
    props: {
        filterItem: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            filterType: this.filterItem.type,
            pagination: {
                page: 0,
                size: this.$constants.QUERY_ALL_SIZE
            }
        };
    },
    methods: {
        clickFilter(item, type) {
            this.setByType(item, type);
        },
        isFilterClick(item, type) {
            if (!item && !this.getByType(type)) {
                return true;
            }
            if (item) {
                return this.getByType(type) === item.id;
            }
            return false;
        },
        getByType(type) {
            const searchForm = this.$store.getters["home/searchForm"];
            switch (type) {
                case FilterTypes.ORG:
                    return searchForm.orgId;
                case FilterTypes.CLASSIFICATIONS:
                    return searchForm.classificationId;
                case FilterTypes.OCCUPATIONS:
                    return searchForm.occupationId;
                case FilterTypes.LEVELS:
                    return searchForm.occupationLevel;
                case FilterTypes.CERTIFICATE_TYPES:
                    return searchForm.certificateType;
                case FilterTypes.REGISTRATION_STATUS:
                    return searchForm.registrationStatus;
                case FilterTypes.SORT_KEY:
                    return searchForm.sortKey;
                default:
                    return "";
            }
        },
        setByType(item, type) {
            const filterValue = item ? item.id : "";
            switch (type) {
                case FilterTypes.ORG: {
                    this.orgId({ filterValue: filterValue });
                    const params = _.merge({}, this.pagination, {
                        orgId: item ? item.id : ""
                    });
                    this.$store.dispatch("base/mapperClassifications", { params: params }).then(() => {
                        this.classificationId({ filterValue: "" });
                        if (_.isEmpty(this.$store.getters["base/classifications"])) {
                            this.$store.commit("base/occupations", []);
                            return;
                        }
                        this.$store.dispatch("base/mapperOccupations", { params: params });
                        this.occupationId({ filterValue: "" });
                    });
                    break;
                }
                case FilterTypes.CLASSIFICATIONS: {
                    this.classificationId({ filterValue: filterValue });
                    const params = _.merge({}, this.pagination, {
                        classificationId: item ? item.id : "",
                        orgId: this.$store.getters["home/searchForm"].orgId
                    });
                    this.occupationId({ filterValue: "" });
                    this.$store.dispatch("base/mapperOccupations", { params: params });
                    break;
                }
                case FilterTypes.OCCUPATIONS:
                    this.occupationId({ filterValue: filterValue });
                    break;
                case FilterTypes.LEVELS:
                    this.occupationLevel({ filterValue: filterValue });
                    break;
                case FilterTypes.CERTIFICATE_TYPES:
                    this.certificateType({ filterValue: filterValue });
                    break;
                case FilterTypes.REGISTRATION_STATUS:
                    this.registrationStatus({ filterValue: filterValue });
                    break;
                case FilterTypes.SORT_KEY:
                    this.sortKey({ filterValue: filterValue });
                    break;
                default:
                    break;
            }
        },
        ...mapActions([
            "orgId",
            "keyword",
            "classificationId",
            "occupationId",
            "occupationLevel",
            "certificateType",
            "registrationStatus",
            "sortKey"
        ])
    }
});
